/** @format */

import { Row } from 'components/ui/Grid';
import styled from 'styled-components';

const Wrapper = styled(Row)`
  justify-content: space-between;
  position: static;
  padding: 20px 1.25rem;
`;

Wrapper.displayName = '   Wrapper';
export default Wrapper;
